import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { createModal, useModalize } from '@/components/modalize/mui'
import { colors } from '@/styles'
import { NamedWizard } from '@/components/wizard'
import DirectDepositWizardForm from './direct-deposit-form'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const ContentWrapper = styled.div`
  width: 100%;
`

const WizardWrapper = styled.div`
  width: 100%;
  border-bottom: 1px solid ${colors.mediumLightGrey};
`

const StyledNamedWizard = styled(NamedWizard)`
  margin: 8px auto 0;
  max-width: 720px;
  background: transparent;
  border-bottom: none;
`

const AddDirectDepositModal = () => {
  const { t } = useTranslation()
  const { close } = useModalize()
  const [currentStep, setCurrentStep] = useState('personal_info')

  const WIZARD_STEPS = {
    personal_info: t('b.payment_settings.edit.general_information.text', 'General Information'),
    financial_info: t(
      'b.payment_settings.edit.financial_information.text',
      'Financial Information'
    ),
    review: t('b.payment_settings.edit.review_terms.text', 'Review Terms')
  }

  const handleBack = () => {
    if (currentStep === 'financial_info') {
      setCurrentStep('personal_info')
    } else if (currentStep === 'review') {
      setCurrentStep('financial_info')
    } else {
      close()
    }
    window.scrollTo(0, 0)
  }

  const onSuccess = () => {
    close()
  }

  return (
    <Wrapper>
      <WizardWrapper>
        <StyledNamedWizard steps={WIZARD_STEPS} currentStep={currentStep} />
      </WizardWrapper>
      <ContentWrapper>
        <DirectDepositWizardForm
          currentStep={currentStep}
          setCurrentStep={setCurrentStep}
          handleBack={handleBack}
          onSuccess={onSuccess}
          isModal
        />
      </ContentWrapper>
    </Wrapper>
  )
}

const show = createModal(AddDirectDepositModal, {
  clickOutside: false,
  showClose: false,
  width: '100%',
  maxWidth: '726px',
  overflow: 'var(--dropdown)'
})

export default show
